<template>
  <div>
    <div v-if="type == 'general'" class="section_general_topic">
      <p class="ml-2 px-2 m-0 text-left font-title">
        {{ title }}
      </p>
      <p class="ml-2 px-2 m-0 text-left font-sub-title">
        {{ subtitle }}
      </p>
    </div>
    <div v-if="type == 'report'" class="section_report_topic">
      <p class="ml-2 px-2 m-0 text-left font-title">
        {{ title }}
      </p>
      <p class="ml-2 px-2 m-0 text-left font-sub-title">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "name_section",
  props: {
    title: null,
    subtitle: null,
    type: null,
  },
};
</script>

<style scoped></style>
